<template>
    <!-- Pra ficar centralizado na tabela, colocar classe 'empty' no data-table -->
    <div class="empty-outer">
        <div class="empty-inner">
            <svg class="empty">
                <use :xlink:href="require('@/assets/img/icons/alert-circle.svg') + '#layer'"></use>
            </svg>
            <div class="empty-text" v-html="msg != '' ? $t(msg) : ''" />
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        msg: {
            type: String,
            default: 'msg-no-results',
        },
    },
};
</script>

<style lang="scss" scoped>
.empty-outer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    color: $darker-gray-color;

    .empty-inner {
        text-align: center;

        .empty {
            fill: #898989;
            width: 50px !important;
            height: 50px !important;
        }

        .empty-text {
            font-weight: 600;
        }
    }
}
</style>
